module.exports = __webpack_public_path__ + "img/LS20130822_greenfire_004.b8fa449b.jpg";